/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_TitleInputs */

const es_prompt_tips_title = /** @type {(inputs: Prompt_Tips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips para mejores resultados`)
};

const en_prompt_tips_title = /** @type {(inputs: Prompt_Tips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips for better results`)
};

/**
* | output |
* | --- |
* | "Tips for better results" |
*
* @param {Prompt_Tips_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_title = /** @type {((inputs?: Prompt_Tips_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_title(inputs)
	return en_prompt_tips_title(inputs)
});
export { prompt_tips_title as "prompt_tips.title" }